import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { IdentityService } from '../_services/identity.service';
import { ToastrService } from 'ngx-toastr';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css']
 })
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;

    constructor(
          private modal:NgbModal,
        private formBuilder: FormBuilder,
   
        private router: Router,
        private toastr: ToastrService,
        public authService: IdentityService) { }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required]
        });

        if (localStorage.getItem('currentUser')) {
            this.authService.doLogout();
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    tryLogin() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        const value = {
            username: this.f.email.value,
            password: this.f.password.value
        };
        this.authService.dologin(value).subscribe(res=>{
            this.setUserInStorage(res);
            let returnUrl = '/dashboard';
            if (this.returnUrl) {
                returnUrl = this.returnUrl;
            }
            this.router.navigate([returnUrl]);
        },err=>{
            this.toastr.error('','Kullanıcı bilgileri hatalı.');
            this.submitted = true;
        });
            // .then(res => {
            //     this.setUserInStorage(res);
            //     localStorage.removeItem('currentLayoutStyle');
            //     let returnUrl = '/dashboard';
            //     if (this.returnUrl) {
            //       returnUrl = this.returnUrl;
            //     }
            //     this.router.navigate([returnUrl]);
            // }, err => {
            //     this.submitted = false;
            //     this.alertService.error(err.message);
            // });
    }

    setUserInStorage(res) {
        if (res.user) {
            localStorage.setItem('currentUser', JSON.stringify(res.user));
        } else {
            localStorage.setItem('currentUser', JSON.stringify(res));
        }
    }


     openreset(){
        const modalref=  this.modal.open(ForgetPasswordComponent, { size: 'lg' });
       
   
        }
}
